import { Navigate } from 'react-router-dom';
import { IRoute, PageType, PortalRoutePath } from '@models';
import { Tr } from '@utils';
import { Permission } from '@services';
import { ConvertIcon } from '@components/icons';
import { ConversionList } from './ConvertionList';
import { SingleSuggestion } from './SingleSuggestion';
import { CarBandListSuggestions } from './CarBandListSuggestions';
import { CarBandListAssignments } from './CarBandListAssignments';

export const CONVERSION_LIST_ROUTES: IRoute = {
	path: PortalRoutePath.CONVERSION_LIST,
	icon: <ConvertIcon />,
	text: <Tr.Portal path="conversion-list.title" />,
	canActivate: (_route, user) =>
		user?.isSellerLoggedInAsManager() || (!user?.isManager() && !!user?.hasPermission([Permission.RUN_SIMULATION])),
	children: [
		{
			path: '',
			element: <ConversionList />
		},
		{
			path: 'single-suggestion/:taskId',
			hideFromMenu: true,
			element: <SingleSuggestion />,
			pageType: PageType.FULLSCREEN
		},
		{
			path: 'car-band-list-suggestions/:id',
			hideFromMenu: true,
			element: <CarBandListSuggestions />,
			pageType: PageType.FULLSCREEN
		},
		{
			path: 'car-band-list-assignments/:id',
			hideFromMenu: true,
			element: <CarBandListAssignments />,
			pageType: PageType.FULLSCREEN
		},
		{
			index: true,
			path: '*',
			hideFromMenu: true,
			element: <Navigate to={{ pathname: '..' }} replace />
		}
	]
};
